import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type NumberTransform from 'teacher-ui-client/transforms/number'

export default class SchoolTrialCount extends Model {
  @attr<NumberTransform>('number') declare studentTrialCount: number

  @attr<NumberTransform>('number') declare teacherTrialCount: number

  @attr<StringTransform>('string') declare subscriptionType: string;

  [Type] = 'school-trial-count' as const
}
